var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import * as Styled from './RowBase.styled';
import { getClosestLabel } from '../ContentSystem/utils/utils';
/**
 *
 * Displays a row with a title, subtitle, and icon. The row can be clicked to trigger an action.
 *
 * @example
 * ```
 * <RowBase
 *   title="My Row Title"
 *   onPrimaryActionClick={() => console.log('Row clicked')}
 *   icon={<MyIconComponent />}
 *   colorMode="day"
 *   padding="8px"
 *   verticalCenter={true}
 *   titleWeight="bold"
 *   titleSize="regular"
 *   subtitle="This is a subtitle"
 *   failSafeLinkText="Click in case of failure"
 *   ariaLabel="Row base example"
 *   isOpen={false}
 * />
 * ```
 * */
var RowBase = function (_a) {
    var title = _a.title, onPrimaryActionClick = _a.onPrimaryActionClick, icon = _a.icon, _b = _a.colorMode, colorMode = _b === void 0 ? 'day' : _b, _c = _a.padding, padding = _c === void 0 ? '0px' : _c, _d = _a.verticalCenter, verticalCenter = _d === void 0 ? false : _d, _e = _a.titleWeight, titleWeight = _e === void 0 ? 'bold' : _e, _f = _a.titleSize, titleSize = _f === void 0 ? 'regular' : _f, _g = _a.subtitle, subtitle = _g === void 0 ? '' : _g, _h = _a.failSafeLinkText, failSafeLinkText = _h === void 0 ? '' : _h, _j = _a.ariaLabel, ariaLabel = _j === void 0 ? '' : _j, _k = _a.isOpen, isOpen = _k === void 0 ? false : _k, _l = _a.index, index = _l === void 0 ? 0 : _l, props = __rest(_a, ["title", "onPrimaryActionClick", "icon", "colorMode", "padding", "verticalCenter", "titleWeight", "titleSize", "subtitle", "failSafeLinkText", "ariaLabel", "isOpen", "index"]);
    var ref = useRef(null);
    var _m = useState(null), dataLabel = _m[0], setDataLabel = _m[1];
    useEffect(function () {
        var parentLabel = getClosestLabel(ref);
        setDataLabel("".concat(parentLabel, "_CTA").concat(index + 1));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Styled.RowBase, __assign({ ref: ref, colorMode: colorMode, onClick: onPrimaryActionClick, padding: padding, verticalCenter: verticalCenter, "aria-label": ariaLabel, "data-label": dataLabel, isOpen: isOpen }, props),
            React.createElement(Styled.TextContainer, null,
                title && (React.createElement(Styled.Title, { titleWeight: titleWeight, titleSize: titleSize, colorMode: colorMode, "data-testid": "row-title" }, title)),
                subtitle && (React.createElement(Styled.Subtitle, { colorMode: colorMode }, subtitle)),
                failSafeLinkText && (React.createElement(Styled.FailSafeLink, { tabIndex: -1, colorMode: colorMode }, failSafeLinkText))),
            icon && React.createElement(Styled.Icon, null, icon))));
};
export default RowBase;
